// extracted by mini-css-extract-plugin
export default {"next_order":"Bz","recurringdis":"Cz","reactivate_button":"Ez","order__summary_title":"Fz","order__summary_items":"Gz","order__summary_item":"Hz","order__summary_item_title":"Iz","order__summary_item_quantity":"Jz","order__item_separator":"Kz","discount":"Lz","promowrapper":"Mz"};
    if(module.hot) {
      // 1737143655398
      var cssReload = require("../../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  